import axios from 'axios';
import {backendHost} from '../../config';

export const putMedia = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/media`, params);
};